// Normalização e dígito verificador de CNPJ (numérico ou alfanumérico) e CPF

export function somenteDigitos(value) {
  return String(value || '').replace(/\D/g, '')
}

export function normalizarCnpj(value) {
  return String(value || '')
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '')
}

function sequenciaRepetida(value) {
  return /^(.)\1+$/.test(value)
}

// Algoritmo oficial: mod 11 sobre "código ASCII - 48", válido para CNPJ numérico e alfanumérico
export function isCnpjValido(value) {
  const cnpj = normalizarCnpj(value)
  if (cnpj.length !== 14 || sequenciaRepetida(cnpj)) return false
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false

  const valores = cnpj.split('').map(char => char.charCodeAt(0) - 48)
  const calcularDv = pesos => {
    const soma = pesos.reduce((acc, peso, index) => acc + peso * valores[index], 0)
    const resto = soma % 11
    return resto < 2 ? 0 : 11 - resto
  }
  const dv1 = calcularDv([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  const dv2 = calcularDv([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  return dv1 === valores[12] && dv2 === valores[13]
}

export function isCpfValido(value) {
  const cpf = somenteDigitos(value)
  if (cpf.length !== 11 || sequenciaRepetida(cpf)) return false

  const digitos = cpf.split('').map(Number)
  const calcularDv = quantidade => {
    const soma = digitos
      .slice(0, quantidade)
      .reduce((acc, digito, index) => acc + digito * (quantidade + 1 - index), 0)
    const resto = (soma * 10) % 11
    return resto === 10 ? 0 : resto
  }
  return calcularDv(9) === digitos[9] && calcularDv(10) === digitos[10]
}
